/* ================================================
   Sole of Seoul – Custom JS
   Update-sichere Anpassungen
   ================================================ */

// Auto-open FAQ accordion via URL hash
function openFaqFromHash() {
  const hash = window.location.hash;
  if (!hash) return;

  const map = {
    '#versandkosten': ['Wie hoch sind die Versandkosten', 'How much is shipping'],
    '#rueckgaberecht': ['Rückgaberecht', 'Return Policy']
  };

  const searchTexts = map[hash];
  if (!searchTexts) return;

  const summaries = document.querySelectorAll('details.details summary');
  for (const summary of summaries) {
    if (searchTexts.some(text => summary.textContent.includes(text))) {
      const details = summary.closest('details');
      details.open = true;
      details.scrollIntoView({ behavior: 'smooth' });
      return;
    }
  }
}

customElements.whenDefined('accordion-custom')
  .then(() => setTimeout(openFaqFromHash, 200))
  .catch(() => setTimeout(openFaqFromHash, 200));

setTimeout(openFaqFromHash, 500);
setTimeout(openFaqFromHash, 1000);




